var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPageblagLogoSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.0527,
    y: 1.21973,
    width: 130,
    height: 130,
    rx: 28,
    transform: "rotate(25.0544 55.0527 1.21973)",
    fill: "#C23D3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9651 53.8764C46.549 99.6898 45.564 103.717 51.3996 118.112C55.3717 128.047 60.3593 132.353 73.2153 137.106C82.8402 140.708 94.9536 139.37 102.885 133.923C109.598 129.163 116.767 116.898 118.404 107.252C122.034 84.8956 98.8636 64.1918 76.7565 70.0126C73.4355 70.9732 70.321 71.4918 69.8791 71.2852C69.4372 71.0786 74.5731 58.9399 81.3904 44.3562L93.7856 17.8405L90.1029 16.1189L86.4201 14.3974L67.9651 53.8764ZM106.481 88.2157C111.771 95.7146 112.316 102.611 108.085 113.198C101.679 129.59 89.9756 135.427 74.1925 130.024C64.7246 126.854 56.98 117.31 56.2295 108.164C55.5079 100.108 62.0306 85.3868 68.6648 80.4106C79.5746 72.048 97.6379 75.6454 106.481 88.2157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageblagLogoSquare);
export default __webpack_public_path__ + "static/media/landing_page.blag_logo_square.a33c81c98774a687e7cf8bba64bee285.svg";
export { ForwardRef as ReactComponent };